import Behaviour from '@/core';
import { Collapse } from 'bootstrap';

export default class Accordion extends Behaviour {
	constructor(el) {
		super(el);
		// this.collapseElementList = [...el.querySelectorAll('.acc-collapse')];
		// this.collapseList = this.collapseElementList.map(collapseEl => {
		// 	return new Collapse(collapseEl, {
		// 		parent: el,
		// 		toggle: false,
		// 	});
		// });
	}

	unmount = () => {
		// this.collapseList.forEach(item => {
		// 	item.dispose();
		// });
	};
}
